export default __webpack_public_path__ + "static/media/delete.8a13a5ac.png";